module.exports = __webpack_public_path__ + "img/Image01.230bfd7e.png";